import './PortProductListPage.css'
import 'antd/dist/reset.css'
import React from 'react'
import { ConfigProvider, Row, Col, Button, Space, Input } from 'antd'
import PortBottomLayout from '../common/PortBottomLayout'
import {
  products,
  getVarietyByVid,
  getProductsOfVariety,
} from '../../products/ProductProvider'

export default class PortProductListPage extends React.Component {
  constructor(props) {
    super(props)
    const [vid, variety] = this.getVidAndVariety(this.props.location.search)
    this.state = {
      vid: vid,
      variety: variety,
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  componentWillReceiveProps = async (nextProps) => {
    if (this.props.location.search !== nextProps.location.search) {
      const [vid, variety] = this.getVidAndVariety(nextProps.location.search)
      this.setState({
        vid: vid,
        variety: variety,
      })
      return true
    }
  }

  render() {
    return (
      <div>
        <div className="PortProductListHeader">
          <ConfigProvider
            theme={{
              components: {
                Input: {
                  activeBorderColor: 'white',
                  hoverBorderColor: 'white',
                },
              },
            }}
          >
            <Input.Search
              allowClear
              addonBefore={
                <div className="PortProductListTitle">
                  {this.state.variety ? this.state.variety.name : '全部产品'}
                </div>
              }
              placeholder="输入产品名称搜索"
              size="middle"
              style={{ background: '#000000' }}
              onChange={(e) => {
                this.setState({ keyword: e.target.value })
              }}
            />
          </ConfigProvider>
        </div>

        <div className="PortProductListPage">
          {this.getProducts()}

          <PortBottomLayout {...this.props} />
        </div>
      </div>
    )
  }

  getProducts = () => {
    var rawSource = this.state.variety
      ? getProductsOfVariety(this.state.variety.vid, 0)
      : products
    var datasource = this.state.keyword
      ? rawSource.filter((p) => p.name.includes(this.state.keyword))
      : [...rawSource]
    return (
      <div className="PortProductListGridWrapper">
        <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32, xl: 40, xxl: 48 }, 20]}>
          {datasource.map((product) => (
            <Col span={12}>{this.getProductCard(product)}</Col>
          ))}
        </Row>
      </div>
    )
  }

  getProductCard = (product) => {
    return (
      <div
        className="PortProductListGrid"
        onClick={() => this.viewProductDetail(product.pid)}
      >
        <img className="PortProductListGridImage" src={product.picture} />
        <div className="PortProductListGridName">{product.name}</div>
        <div className="PortProductListGridLink">
          <Space size={'large'}>
            {product.purchasable
              ? this.getCommonLinkButton(product)
              : this.getCommonConsultButton()}
            <Button
              type="default"
              size="small"
              style={{
                fontSize: 10,
                paddingLeft: 5,
                paddingRight: 5,
                paddingTop: 2,
                paddingBottom: 2,
                fontFamily: 'MyCustomizedFont',
              }}
              onClick={() => this.viewProductDetail(product.pid)}
            >
              了解更多
            </Button>
          </Space>
        </div>
      </div>
    )
  }

  getCommonLinkButton = (product) => {
    return (
      <Button
        type="primary"
        size="small"
        style={{
          fontSize: 10,
          paddingLeft: 5,
          paddingRight: 5,
          paddingTop: 2,
          paddingBottom: 2,
          fontFamily: 'MyCustomizedFont',
        }}
        onClick={() => {
          this.gotoShop(product)
        }}
      >
        立即购买
      </Button>
    )
  }

  getCommonConsultButton = () => {
    return (
      <Button
        color="pink"
        variant="filled"
        size="small"
        style={{
          fontSize: 10,
          paddingLeft: 5,
          paddingRight: 5,
          paddingTop: 2,
          paddingBottom: 2,
          fontFamily: 'MyCustomizedFont',
        }}
        onClick={(e) => {
          e.stopPropagation()
          this.viewContact()
        }}
      >
        咨询购买
      </Button>
    )
  }

  getVidAndVariety = (search) => {
    var i = search.indexOf('vid=')
    var vid = parseInt(search.substring(i + 4, search.length))
    var variety = getVarietyByVid(vid)
    return [vid, variety]
  }

  viewProductDetail = (pid) => {
    var url = '/product?pid=' + pid
    if (this.state.variety) {
      url += '&vid=' + this.state.variety.vid
    }
    this.props.history.push(url)
  }

  viewContact = () => {
    this.props.history.push('/contact')
  }

  gotoShop = (product) => {
    window.open(product.link, '_blank')
  }
}
